import { AudioGraph } from "../AudioGraph";
import { AudioGraphNodeType } from "../AudioGraphNodeType";

export abstract class AudioGraphNode<T>
{
  private _id:number;
  get id(){ return this._id;}

  private _graph:AudioGraph;
  get graph(){ return this._graph; }
  
  protected _node:T;
  get node(){ return this._node; }
  
  private _type:AudioGraphNodeType;
  get type(){ return this._type; }
  
  private _initialized = false;
  get initialized(){ return this._initialized; }

  constructor( graph:AudioGraph, id:number, type:AudioGraphNodeType )
  {
    this._id = id;
    this._type = type;
    this._graph = graph;
  }

  protected get _context()
  {
    return this._graph.context;
  }
  
  initialize()
  {
    if ( this._initialized )
    {
      return;
    }

    this._assignAudioNode();

    this._initialized = true;
  }

  connectToOutput()
  {
    return this.graph.createConnection( this.id, 0 );
  }

  connect( target:AudioGraphNode<any> )
  { 
    return this.graph.createConnection( this.id, target.id );
  }

  connectChannels( ownChannel:number, target:AudioGraphNode<any>, targetChannel:number )
  {
    return this.graph.createConnection( this.id, target.id, ownChannel, targetChannel );
  }

  protected abstract _assignAudioNode():void;
  
  static connectLinear( nodes:AudioGraphNode<any>[] )
  {
    for ( let i = 0; i < nodes.length - 1; i++ )
    {
      nodes[ i ].connect( nodes[ i + 1 ] );
    }
  }

  static connectLinearToOutput( nodes:AudioGraphNode<any>[] )
  {
    AudioGraphNode.connectLinear( nodes );
    nodes[ nodes.length - 1 ].connectToOutput();
  }
}